import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "modalHeader bigTitle" }
const _hoisted_3 = { class: "modalBody container-fluid" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "midTitle mb-2" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "midTitle mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger fs-22 mt-3"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "midTitle mb-2" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "midTitle mb-2" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Lista", -1)
const _hoisted_17 = { value: null }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "modalFooter" }
const _hoisted_21 = { class: "text-right" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_personal_data = _resolveComponent("personal-data")!
  const _component_auth_data = _resolveComponent("auth-data")!
  const _component_contact_data = _resolveComponent("contact-data")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Nuovo lead",
        text: "Nuovo lead"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_localized_text, {
              localizedKey: "Dati personali",
              text: "Dati personali"
            })
          ]),
          _createVNode(_component_personal_data, {
            value: _ctx.vm.personalData
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_localized_text, {
              localizedKey: "Dati di accesso",
              text: "Dati di accesso"
            })
          ]),
          (!_ctx.isMailAvailable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Email già registrata",
                  text: "Email già registrata"
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_auth_data, {
            value: _ctx.vm.authData
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_localized_text, {
              localizedKey: "Dati di contatto",
              text: "Dati di contatto"
            })
          ]),
          _createVNode(_component_contact_data, {
            value: _ctx.vm.contactData
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_localized_text, {
              localizedKey: "Altri",
              text: "Altri"
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vm.list) = $event))
            }, [
              _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$localizationService.GetLocalizedValue("Seleziona lista", "Seleziona lista")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (item, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_18))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.vm.list]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Product level",
                text: "Product level"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.productLevel) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.productLevel]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary mb-5",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveModify && _ctx.saveModify(...args))),
          disabled: !_ctx.canSend
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Salva e modifica",
            text: "Salva e modifica"
          })
        ], 8, _hoisted_22),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary mb-5",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveChiudi && _ctx.saveChiudi(...args))),
          disabled: !_ctx.canSend
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Salva e chiudi",
            text: "Salva e chiudi"
          })
        ], 8, _hoisted_23)
      ])
    ])
  ]))
}